"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Human = function Human(_ref) {
  var offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    viewBox: "0 0 487 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M200.41 444.74h-48.94l-41.45-21.48 9.39-19.1-24.65-13.92-45.97-57.14 9.69-11.92-26.9-19.06L0 234.95l16.36-14.42L.900002 200.12 40.57 81.8l30.47-6.48 1.49-31.14 79.36-39.94L205.85 0l29.77 29.86-.02 327.65-2.99 43.58-32.2 43.65zm-45.01-16.13h36.86l24.58-33.32 2.64-38.61V36.53l-19.8-19.86-43.37 3.41-68.12 34.27-1.63 34.15-33.63 7.16L18.9 197.17l19.37 25.56-18.52 16.32 24.62 52.37L81.87 318l-12.34 15.17 35.85 44.56 35.22 19.89-9.14 18.59 23.94 12.4z",
    fill: offsetColor
  }), _react.default.createElement("path", {
    d: "M158.549 369.35l-13.39-8.99 41.5-61.8-68.3-78.18 55.19-45.3-115.5099-32.8L176.729 78.9596l-9.16-44.89 15.8-3.22 11.57 56.68-94.02 50.1504 106.7 30.3-66.17 54.31 65.5 74.99-48.4 72.07zM334.71 444.74h-48.94l-32.2-43.66-3-44.13V29.86L280.33 0l53.96 4.24 79.36 39.94 1.49 31.14 30.47 6.48 39.67 118.32-15.46 20.41 16.36 14.42-31.58 67.17-26.9 19.06 9.69 11.92-45.97 57.14-24.65 13.92 9.39 19.1-41.45 21.48zm-40.79-16.13h36.86l23.94-12.4-9.14-18.59 35.22-19.89 35.85-44.56L404.31 318l37.5-26.58 24.62-52.37-18.52-16.32 19.37-25.56-34.03-101.51-33.63-7.16-1.63-34.15-68.12-34.28-43.37-3.41-19.8 19.86v320.15l2.64 38.61 24.58 33.33z",
    fill: offsetColor
  }), _react.default.createElement("path", {
    d: "M327.631 369.35l-48.4-72.07 65.5-74.99-66.17-54.31 106.7-30.3-94.02-50.1504 11.57-56.68 15.8 3.22-9.16 44.89 118.69 63.3204-115.51 32.8 55.19 45.3-68.3 78.18 41.5 61.8-13.39 8.99zM332.819 461.93h-179.46v16.13h179.46v-16.13zM320.041 490.09h-153.91v16.13h153.91v-16.13zM305.44 518.24H180.73v16.13h124.71v-16.13zM258.581 574.869h-30.98l4.36 6.94-12.85 8.08v1.11h48.06v-1.04l-12.95-8.15 4.36-6.94z",
    fill: offsetColor
  }), _react.default.createElement("path", {
    d: "M227.601 574.869l-13.41-21.33h-19.05l23.97 37.46v-16.13h8.49z",
    fill: offsetColor
  }), _react.default.createElement("path", {
    d: "M227.601 574.869h-8.49v15.02l12.85-8.08-4.36-6.94zM258.58 574.869h8.59v16.13l23.87-37.46h-19.05l-13.41 21.33z",
    fill: offsetColor
  }), _react.default.createElement("path", {
    d: "M258.581 574.869l-4.36 6.94 12.95 8.15v-15.09h-8.59z",
    fill: offsetColor
  }));
};

Human.propTypes = {
  offsetColor: _propTypes.default.string
};
Human.defaultProps = {
  offsetColor: "#63DC3E"
};
var _default = Human;
exports.default = _default;